import script from "./C0002Main.vue?vue&type=script&setup=true&lang=js"
export * from "./C0002Main.vue?vue&type=script&setup=true&lang=js"

import "./C0002Main.vue?vue&type=style&index=0&id=426b2261&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/TagDesign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426b2261"]])

export default __exports__